module.exports = __webpack_public_path__ + "static/media/DSC00199 - Version 2.2c1a00dc.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/items/DSC00199 - Version 2.JPG
// module id = 499
// module chunks = 0